<template>
  <div id="orderList">
    <div class="head-status-box">
      <el-row :gutter="20">
        <el-col :span="20">
          <!-- <div
            @click="setStatus(0)"
            :class="checkStatus == 0?'status-button-click':''"
            class="status-button"
          >{{headStatusButton[0]}}</div>
        </el-col>
        <el-col
          :span="3"
          v-for="(item,index) in headStatusButton"
          v-show="item != '' && index != 0"
          :key="index"
        >
          <div
            @click="setStatus(index)"
            :class="checkStatus == index?'status-button-click':''"
            class="status-button"
          >{{item}}</div> -->
          
            <div
            class="status-button "
            @click="searchOrder('')"
            v-bind:class="{ 'status-button-click': status == '' }"
          >
            全部申请(
            <i>{{count0}}</i>
            )
          </div>
          <div class="status-button" @click="searchOrder(1)" v-bind:class="{ 'status-button-click': status == 1}">
            待处理(
            <i>{{count1}}</i>
            )
          </div>

          <div class="status-button" @click="searchOrder(2)" v-bind:class="{ 'status-button-click': status == 2 }">
            退货中(
            <i>{{count2}}</i>
            )
          </div>
          <div class="status-button" @click="searchOrder(4)" v-bind:class="{ 'status-button-click': status == 4 }">
            已完成(
            <i>{{count3}}</i>
            )
          </div>
          <div class="status-button" @click="searchOrder(3)" v-bind:class="{ 'status-button-click': status == 3}">
            已拒绝(
            <i>{{count4}}</i>
            )
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="head-search-box">
      <div class="search-title">
        <span style="margin-left:16px">筛选查询</span>
        <div class="search-button" @click="searchOrder">搜 索</div>
      </div>
      <div class="search-input">
        <el-row :gutter="20">
          <el-col :span="7" style="margin-left:16px;">
            <div class="input-box">
              <span style="width:95px;margin-right:10px;">请输入搜索 :</span>
              <el-input
                style="width:200px"
                clearable
                v-model="searchForm.orderCode"
                placeholder="请输入订单编号"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="input-box">
              <span style="width:90px;">提交时间 :</span>
              <el-date-picker
                v-model="searchForm.timeValue"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-col>

          <el-col :span="6"></el-col>
        </el-row>
      </div>
      <div class="table-box">
        <div class="table-head">
          <div style="margin-left:13px;">
            <i class="iconfont icon-liebiao" style="color:#666666"></i> 数据列表
          </div>
          <div style="width:100px;margin-right:21px;">
            <el-select v-model="limit" size="small" @change="limitChange()">
              <el-option
                v-for="(item,index) in showLimit"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="table">
          <template>
            <el-table
              :header-cell-style="{
                'background-color': '#F5FAF9'
                }"
              :data="tableData"
              border
              v-loading="loading"
              style="width: 100%"
            >
              <el-table-column align="center" prop="code" label="服务单号" width="180"></el-table-column>
              <el-table-column align="center" prop="create_date" label="申请时间" width="180"></el-table-column>
              <el-table-column align="center" prop="mobile" label="用户账号"></el-table-column>
              <el-table-column align="center" prop="return_money" label="退款金额"></el-table-column>
              <el-table-column align="center" prop="status" label="申请状态"></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-link
                    v-if="scope.row.status == 0"
                    @click="showAlertMessage = true,alertMessageIndex = scope.$index,alertString()"
                  >提醒付款</el-link>
                  <el-link
                    v-else-if="scope.row.status == 2 || scope.row.status == 1"
                    @click="showShipment = true,shipmentId = scope.row.id"
                  >确认发货</el-link> 

                  <router-link
                    v-else
                    target="_blank"
                    :to="'./orderReturnDetail2/' + scope.row.return_id "
                    style="text-decoration: none;"
                  >
                    <el-link>查看订单</el-link>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="page-box" v-show="pageTotal > limit">
              <div style="margin-top:7px">
                <el-pagination
                  hide-on-single-page
                  background
                  layout="total,prev, pager, next"
                  :total="pageTotal"
                  :page-size="limit"
                  @current-change="setPage"
                ></el-pagination>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      serve: this.$store.state.serve,
      token: this.$cookies.get("shop_token"),
      resType: 1,

      checkStatus: "",
      status: '',
      showLimit: [
        { label: "每页10条", value: 10 },
        { label: "每页15条", value: 15 },
        { label: "每页20条", value: 20 },
        { label: "每页50条", value: 50 }
      ],
      searchForm: {
        orderCode: "",
        timeValue: ""
      },
      limit: 15,
      tableData: [],
      pageTotal: 0,
      page: 0,
      count0: '',
      count1: '',
      count2: '',
      count3: '',
      count4: ''
    };
  },
  created() {
    this.$store.state.shop_top = 2;
    this.$store.state.shop_left = "退货申请";

    this.getList();
  },
  methods: {

    setPage(page) {
      this.page = page;
      this.getList();
    },
    limitChange() {
      this.getList();
    },
    setStatus(index) {
      this.checkStatus = index;
      this.page = 0;
      this.pageTotal = 0;
      switch (index) {
        case 0:
          this.status = "";
          break;
        case 1:
          this.status = 0;
          break;
        case 2:
          this.status = 1;
          break;
          this.status = 6;
          break;
      }
      this.getList();
    },
    searchOrder(status = '') {
      this.status = status;
      this.tableData = [];
      this.getList();
    },
    getList() {
      var that = this;
      this.loading = true;
      var where = {
        token: this.token,
        page: this.page != 0 ? this.page : "",
        status: this.status
      };
      this.axios
        .get(this.serve + "shop/returnProduct", { params: where })
        .then(res => {
         
          var data = res.data;
          if (data.status == "success") {
            // var tableData = data.data.results;
            // this.tableData = tableData;
            // this.pageTotal = data.data.total;
            var tableData = [];
            var json = data.data;
            // that.count0 = json.status_all;
            // that.count1 = json.status1;
            // that.count2 = json.status4;
            // that.count3 = json.status3;
            // that.page = json.page;
            // that.total = json.total;
            // for (var key in json.results) {
            //   that.tableData.push(json.results[key]);
            //   if (json.results[key].status == "1") {
            //     json.results[key].status = "待处理";
            //   }
            //   if (json.results[key].status == "4") {
            //     json.results[key].status = "已退款";
            //   }
            //   if (json.results[key].status == "3") {
            //     json.results[key].status = "已拒绝";
            //   }
            // }
            if (json) {
              that.page = json.now_page;
              that.total = json.total;
              for (var key in json.results) {
                var time = json.results[key].create_date;
                var timeNew = new Date(parseInt(time) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].create_date = timeNew;
                that.tableData.push(json.results[key]);
                if (json.results[key].status == "1") {
                  json.results[key].status = "待处理";
                }
                if (json.results[key].status == "2") {
                  json.results[key].status = "退货中";
                }
                if (json.results[key].status == "3") {
                  json.results[key].status = "已拒绝";
                }
                if (json.results[key].status == "4") {
                  json.results[key].status = "已完成";
                }
              }
            }
            this.count0 = json.num;
            this.count1 = json.num1;
            this.count2 = json.num2;
            this.count3 = json.num4;
            this.count4 = json.num3;
          } else {
            this.tableData = [];
          }
          // loading.close()
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
#orderList {
  .head-status-box {
    width: 1060px;
    height: 36px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    display: flex;
    .status-button {
      cursor: pointer;
      min-width: 100px;
      height: 34px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 34px;
      text-align: center;
      display: inline-block;
      margin-right: 39px;
    }
    .status-button:hover {
      background: rgba(0, 153, 255, 1);
      color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
    }
    .status-button-click {
      min-width: 100px;
      height: 34px;
      background: rgba(0, 153, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      text-align: center;
    }
    .el-row {
      width: 1060px;
    }
  }
  .head-search-box {
    margin-top: 20px;
    .search-title {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-button {
        line-height: 28px;
        text-align: center;
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        margin-right: 21px;
        cursor: pointer;
      }
      .search-button:hover {
        background: rgba(0, 153, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
    .search-input {
      width: 1060px;
      height: 86px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 86px;
      .input-box {
        display: flex;
        align-items: center;
      }
    }
  }
  .table-box {
    margin-top: 19px;
    margin-bottom: 100px;
    .table-head {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .table {
      width: 1062px;
    }
    .page-box {
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 60px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>